import { Component, inject, OnInit, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ActivatedRoute, Params, Router, RouterLink } from "@angular/router";
import { MatButtonLoadingDirective } from "app/common-ux/button/button-loading.directive";
import { AuthenticationService } from "app/auth/authentication.service";
import { TenantService } from "app/tenant/module/tenant.service";

interface LoginParams extends Params {
    failMessage?: string;
}

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    imports: [
        FormsModule,
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonLoadingDirective,
        RouterLink,
    ],
})
export class LoginComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private authenticationService = inject(AuthenticationService);
    private tenantService = inject(TenantService);

    public loginState = signal({
        isInvalid: false,
        isLoggingIn: false,
        failMessage: "",
    });
    public username = "";
    public password = "";

    public ngOnInit() {
        const params: LoginParams = this.route.snapshot.params;

        if (params.failMessage) {
            this.loginState.update((s) => ({
                ...s,
                isInvalid: true,
                failMessage: params.failMessage!,
            }));
        }
    }

    public async loginOnClick() {
        this.loginState.update((s) => ({ ...s, isLoggingIn: true }));

        try {
            const user = await this.authenticationService.login(this.username, this.password);

            const redirect = this.route.snapshot.params.redirect;
            if (redirect) {
                await this.router.navigateByUrl(redirect);
            } else {
                const url = this.tenantService.getDefaultUrlForUser(user);
                await this.router.navigateByUrl(url);
            }
        } catch (e) {
            this.loginState.set({
                isInvalid: true,
                isLoggingIn: false,
                failMessage: (e instanceof Error && e.message) || "Unknown error",
            });
        }
    }
}
